import { render, staticRenderFns } from "./StackedBarChart.vue?vue&type=template&id=04cac184&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"
import style0 from "./StackedBarChart.vue?vue&type=style&index=0&id=04cac184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cac184",
  null
  
)

export default component.exports